import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">话题热度</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            当前最受读者关注的漫画话题与分类热度
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className={`inline-flex items-center gap-2.5 px-5 py-3 rounded-full ${item.color} text-sm font-medium cursor-pointer hover:scale-105 transition-transform`}
            >
              <span>{item.name}</span>
              <span className="text-xs opacity-70">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}